"use client";
import React, { useEffect } from 'react';
import { SlotContentProps } from './types';
import { useSlotContext } from './SlotContext';

/**
 * SlotContent 组件
 * 在子组件中提供内容，填充到父组件对应 id 的占位符中
 */
export const SlotContent: React.FC<SlotContentProps> = ({
  id,
  children,
}) => {
  // 获取插槽上下文
  const { registerSlot, unregisterSlot } = useSlotContext();
  
  // 组件挂载时注册插槽内容，卸载时注销
  useEffect(() => {
    // 注册插槽内容
    registerSlot(id, children);
    
    // 组件卸载时注销插槽内容
    return () => {
      unregisterSlot(id);
    };
  }, [id, children, registerSlot, unregisterSlot]);

  // 该组件不渲染任何内容，仅负责注册插槽内容
  return null;
};
